import { BehaviorSubject, Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { appDirLookupMap } from './app-config';

export class Configuration {
  // tslint:disable-next-line:no-any
  private static config: any;

  // tslint:disable-next-line:no-any
  private static defaultConfig: any;
  static hasSetSubject = new BehaviorSubject<boolean>(false);
  static readonly isRunningInLocalhost: boolean = document.URL.toString().includes('localhost');

  // tslint:disable-next-line:no-any
  public static get(key: string): any {
    const result = Configuration.getConfigByStringKey(key.split('.'), this.config);
    return this.config && result;
  }

  // tslint:disable-next-line:no-any
  public static getDefaultConfig(): any {
    return this.defaultConfig;
  }

  // tslint:disable-next-line:no-any
  public static getAsync(key: string): Observable<any> {
    return this.hasSetSubject.pipe(
      filter((hasBeenSet) => !!hasBeenSet),
      map(() => {
        const keys = key.split('.');
        const result = Configuration.getConfigByStringKey(keys, this.config);
        return result;
      })
    );
  }

  // tslint:disable-next-line:no-any
  public static setConfig(data: { [key: string]: any }): void {
    this.config = data;
    this.hasSetSubject.next(true);
  }

  // tslint:disable-next-line:no-any
  public static getConfig(): { [key: string]: any } {
    return this.config;
  }

  // tslint:disable-next-line:no-any
  public static getConfigByStringKey(keys: Array<string>, config: any): any {
    if (keys.length === 0 || !config || !config[keys[0]]) {
      return null;
    }

    if (keys.length === 1) {
      return config[keys[0]];
    } else if (keys.length > 1 && !(config[keys[0]] instanceof Object)) {
      return null;
    }

    config = config[keys[0]];
    keys.shift();

    return Configuration.getConfigByStringKey(keys, config);
  }

  // tslint:disable-next-line:no-any
  public static load(path: string, appName: string, extraConfigs?: { [key: string]: any }, isRootApp = false) {
    return fetch(path)
      .then((response) => response.json())
      .then((config) => {
        let jsonConfig = config['default'];
        this.defaultConfig = JSON.parse(JSON.stringify(config['default']));
        let dir: string;
        if (appDirLookupMap[appName] === 'root' || isRootApp) {
          dir = '';
        } else {
          dir = appDirLookupMap[appName] ? `\/${appDirLookupMap[appName]}` : `\/${appName}`;
        }
        return fetch(`${dir}/config/config.json`)
          .then((response) => response.json())
          .then((projConfig) => {
            console.log('App config loaded for ', appName);
            jsonConfig = Configuration.getSerializedConfig(jsonConfig, projConfig, extraConfigs);
            Configuration.setConfig(jsonConfig);
            return jsonConfig;
          })
          .catch((err) => {
            console.log(
              `App config not found for ${appName}, ${err}`
            );
          });
      })
      .catch((err) => {
        console.log('Default Config is not loaded ', err);
        return {};
      });
  }

  private static getSerializedConfig(jsonConfig: any, appConfig: any, extraConfigs: any) {
    for (const appConfigKey in appConfig) {
      if (appConfig[appConfigKey] instanceof Object) {
        if (!jsonConfig[appConfigKey]) {
          jsonConfig[appConfigKey] = {};
        }

        Object.assign(jsonConfig[appConfigKey], appConfig[appConfigKey]);
      } else {
        jsonConfig[appConfigKey] = appConfig[appConfigKey];
      }
    }

    if (!!extraConfigs) {
      jsonConfig = {
        ...jsonConfig,
        ...extraConfigs,
      };
    }

    return jsonConfig;
  }

  public static isProductionEquivalentEnvironment(): boolean {
    return ['prod', 'uat', 'stg'].includes(this.config['environment']);
  }
}
